export default "__VITE_ASSET__CWimx3QG__"